// apps/frontend/src/features/experiential/lib/roleSets.ts
// Role taxonomies for the voice techniques. Each technique passes one of these
// to the ensemble tool; role names are translated under experiential.roles.*.

export interface RoleDef { key: string; defaultVoice: string; }

export const IFS_PARTS: RoleDef[] = [
  { key: "ifs_self", defaultVoice: "Grace" },
  { key: "manager", defaultVoice: "Arthur" },
  { key: "firefighter", defaultVoice: "Jack" },
  { key: "exile", defaultVoice: "Nina" },
  { key: "custom", defaultVoice: "Maya" },
];

export const BUS_PASSENGERS: RoleDef[] = [
  { key: "critic", defaultVoice: "Daniel" },
  { key: "worry", defaultVoice: "Claire" },
  { key: "fear", defaultVoice: "Nina" },
  { key: "shame", defaultVoice: "Elise" },
  { key: "anger", defaultVoice: "Jack" },
  { key: "custom", defaultVoice: "Maya" },
];

export const EMPTY_CHAIR_ROLES: RoleDef[] = [
  { key: "self", defaultVoice: "Maya" },
  { key: "other", defaultVoice: "Daniel" },
];

// MI "playing the tape forward": the urge played to its real ending, then the alternative.
export const TAPE_FORWARD_ROLES: RoleDef[] = [
  { key: "the_tape", defaultVoice: "Mason" },
  { key: "the_alternative", defaultVoice: "Grace" },
];

// EFT couples: the negative cycle voiced from outside.
export const COUPLES_CYCLE_ROLES: RoleDef[] = [
  { key: "pursuer", defaultVoice: "Claire" },
  { key: "withdrawer", defaultVoice: "Daniel" },
];

// Psychoeducation radio play: the brain's characters explain themselves.
export const BRAIN_CAST_ROLES: RoleDef[] = [
  { key: "amygdala", defaultVoice: "Jack" },
  { key: "cortex", defaultVoice: "Arthur" },
  { key: "breath", defaultVoice: "Grace" },
  { key: "custom", defaultVoice: "Maya" },
];

// Playback theatre: the client's moment, performed back.
export const PLAYBACK_ROLES: RoleDef[] = [
  { key: "narrator", defaultVoice: "Arthur" },
  { key: "voice", defaultVoice: "Nina" },
  { key: "custom", defaultVoice: "Maya" },
];

// Tale therapy: the therapeutic story, narrated chapter by chapter.
export const TALE_ROLES: RoleDef[] = [
  { key: "narrator", defaultVoice: "Arthur" },
  { key: "character", defaultVoice: "Nina" },
];

export function defaultVoiceForRole(roles: RoleDef[], key: string): string {
  const role = roles.find((r) => r.key === key);
  if (!role) throw new Error(`unknown role key: ${key}`);
  return role.defaultVoice;
}
